// The docs shelf, as the portal addresses it.
//
// These three functions decide where a guide lives and how the shelf is grouped,
// and they live here rather than in DocsPage because the top bar needs them too.
// They were inline expressions in both places before, which is how the top bar
// and the docs page came to disagree about which guide is the bare
// /documentation — and it also meant TopBar had to import a page module, pulling
// react-markdown and mermaid into its chunk.
//
// Everything here is derived from the backend's guide index
// (GET /docs/guides), which reads each guide's own frontmatter. Publishing a
// guide changes no code.

// The canonical default guide — loads at bare /documentation (no slug in URL).
// The docs landing is the QUICKSTART, not the 5,800-line reference: the
// reference was the first thing a new developer met, and it opens on a table of
// contents with thirty-four entries.
export const DEFAULT_SLUG = 'quickstart';

// The route a guide lives at. The default guide is the bare /documentation,
// which is what the portal sidebar and every "read the docs" link point at.
export function guideHref(slug) {
  return slug === DEFAULT_SLUG ? '/documentation' : `/documentation/${slug}`;
}

// Group the guides into the reading rail's chapters, keeping the order the
// backend's index gives them (frontmatter `order`). `group` is frontmatter too,
// so a new guide declares its own chapter and nothing here needs editing to
// publish one. A guide with no `group` gets the fallback rather than being
// dropped — a published doc that is live, served and invisible is worse than one
// in a vague chapter.
export function toChapters(guides, fallback = 'Guides') {
  const chapters = [];
  for (const g of guides) {
    const label = g.group || fallback;
    let chapter = chapters.find((c) => c.label === label);
    if (!chapter) {
      chapter = { num: String(chapters.length + 1).padStart(2, '0'), label, entries: [] };
      chapters.push(chapter);
    }
    chapter.entries.push({ title: g.title, href: guideHref(g.slug) });
  }
  return chapters;
}
